<template>
    <!-- pageData 通过 mixin 注入 -->
    <div :class="['epassport', pageData.isPhone ? 'phone' : 'pc']">
        <div
            class="el-dialog__wrapper"
            :style="`background-image: url(${bg});`"
        >
            <div class="title">
                <div class="logo">
                    <img
                        src="~images/xxlogo.png"
                    />
                </div>
                <div class="page-title">
                    {{ pageData.title }}
                </div>
            </div>
            <div class="el-dialog">
                <div class="el-dialog__body el-dialog__body_epassport">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const logo = require('images/login_logo.png');
const bg = require('images/login_bg.jpg');

export default {
    data() {
        return { logo, bg };
    },
};
</script>

<style lang="scss">
.vss-layout.phone .epassport {
    .el-dialog {
        transform: none;
        position: relative;
        left: 0;
        margin: 0 auto;
    }
    .title {
        font-size: 20px;
        line-height: 50px;
    }
    .slogan {
        padding: 15px 0 10px;
    }
}
.vss-layout.pc .epassport {
    .el-dialog {
        transform: none;
        position: relative;
        left: 0;
        margin: 0 auto;
    }
    .title {
        line-height: 40px;
        padding-top: 100px;
        padding-bottom: 20px;
    }
    .slogan {
        line-height: 40px;
        padding-top: 55px;
        padding-bottom: 25px;
    }
}
</style>

<style lang="scss" scoped>
.epassport {
    text-align: center;
    .el-dialog__wrapper {
        z-index: 1000;
        background-color: #0a4b77;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        .el-dialog__body {
            padding: 0;
        }
    }
    .el-dialog {
        margin-bottom: 0;
    }
}
.title {
    color: #fff;
    .page-title {
        font-size: 20px;
        letter-spacing: 10px;
    }
}
.logo {
    width: 215px;
    margin: 0 auto;
    img {
        width: 100%;
        height: 100%;
    }
}
.slogan {
    font-size: 16px;
    color: #fefefe;
}
</style>
